export const res = {
  authenticationNumber: {
    is: 'Sláðu inn auðkennisnúmerið',
    en: 'Please enter the authentication number',
    pl: 'Wpisz kod identyfikacyjny',
  } as const,
  validationAuthenticationNumberRequired: {
    is: 'Auðkennisnúmer verður að vera útfyllt',
    en: 'Authentication number is a required field',
    pl: 'Należy wypełnić pole z numerem',
  } as const,
  validationAuthenticationNumberInvalid: {
    is: 'Auðkennisnúmer er ekki rétt skráð',
    en: 'Authentication number is incorrect',
    pl: 'Numer jest niepoprawny',
  } as const,
  info: {
    is: 'Fylgstu með símanum þínum. Við höfum sent auðkennisnúmer í síma ',
    en: 'Check your phone. We’ve sent your authentication number to ',
    pl: 'Sprawdź w swoim telefonie. Na następujący nr telefonu wysłaliśmy kod identyfikacyjny: ',
  } as const,
};
